import {
  Form,
  Button,
  Space,
  Input,
  DatePicker,
  message,
  Select,
  Upload,
  InputNumber,
  Radio,
} from 'antd';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
dayjs.extend(utc);
dayjs.extend(timezone);

import { saveOrUpdate, test } from '@/api/recall';
import { useNavigate } from 'react-router-dom';
import React, { useState } from 'react';
// eslint-disable-next-line import/no-unresolved
import QuillEditer from '@/components/QuillEditer';
import type { RecallEmailSaveOrUpdateReq } from '@/types/recall';
import { RewardTypeEnumMap, UserEnum } from './type';
import axiosInstance from '@/api/axiosInstance';

const userArr = Object.keys(UserEnum).filter((item) => isNaN(Number(item)));


const PushDetail = () => {
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const [form] = Form.useForm();

  const navigator = useNavigate();

  async function onSubmit() {
    const values: RecallEmailSaveOrUpdateReq = await form.validateFields();
    const formattedTime = dayjs(values.publishTime).format(
      'YYYY-MM-DD HH:mm:ss'
    );
    const baseUrl = `${SUPP_ADMIN_BASE_URL}/supp-management`;
    const formData = new FormData();

    const keys = Object.keys(values);
    keys.forEach((key: keyof RecallEmailSaveOrUpdateReq) => {
      if (key === "publishTime") {
        formData.append('publishTime', formattedTime);
      } else {
        const value = values[key];
        if (value) {
          formData.append(key, value);
        }
      }
    })
    // formData.append('title', values.title);
    // formData.append('content', values.content);
    
    // formData.append('pushTargetType', values.pushTargetType.toString());
    if (values.pushTargetType === 6) {
      if (!uploadedFile) {
        return message.error('请先上传Excel文件');
      }
      formData.append('file', uploadedFile);
    }
    try {
      const res = await axiosInstance.post(
        `${baseUrl}/recallEmail/saveOrUpdate`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );
      if (res.data.status !== 200) {
        return message.error(res.data.message || '上传失败');
      }
      message.success(res.data.message || '上传成功');
      onCancel();
    } catch (err) {
      message.error('上传出错');
    }
  }

  async function onSubmitTest() {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const values: RecallEmailSaveOrUpdateReq = await form.validateFields();
    const params: RecallEmailSaveOrUpdateReq = {
      ...values,
      publishTime: dayjs(values.publishTime).format('YYYY-MM-DD HH:mm:ss'),
    };

    const res = await test(params);
    if (res.status !== 200 || res.data.status !== 200) {
      return message.error(res.data.message);
    }

    message.success(res.data.message);
  }

  function onCancel() {
    navigator(-1);
  }

  const testEmail = Form.useWatch('testEmail', form) as string;

  return (
    <div>
      <Form
        form={form}
        initialValues={{
          pushResource: 3,
        }}
      >
        <Form.Item label="推送对象" required>
          <Input.Group compact>
            <Upload
              name="file"
              accept=".xlsx,.xls"
              showUploadList={false}
              beforeUpload={(file) => {
                setUploadedFile(file); // 存文件
                form.setFieldsValue({ pushTargetType: 6 }); // 自动设为 Excel 类型
                return false;
              }}
            >
              <Button
                type="default"
                style={{
                  borderTopRightRadius: 0,
                  borderBottomRightRadius: 0,
                  backgroundColor: '#f0f0f0',
                  borderRight: 'none',
                }}
              >
                excel表单上传
              </Button>
            </Upload>

            <Form.Item
              name="pushTargetType"
              noStyle
              rules={[{ required: true, message: '请选择推送对象' }]}
            >
              <Select
                style={{ width: 'calc(100% - 130px)' }}
                placeholder="请选择推送对象"
                value={form.getFieldValue('pushTargetType')}
              >
                {userArr.map((item) => {
                  const value = UserEnum[item] as string;
                  return (
                    <Select.Option value={value} key={value}>
                      {item}
                    </Select.Option>
                  );
                })}
                {uploadedFile && (
                  <Select.Option value={6} key="excel-upload">
                    {uploadedFile.name}
                  </Select.Option>
                )}
              </Select>
            </Form.Item>
          </Input.Group>
        </Form.Item>
        <Form.Item label="标题" name="title" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item label="正文" name="content" rules={[{ required: true }]}>
          <QuillEditer
            useApi
            uploadConfig={{
              action: `${SUPP_ADMIN_BASE_URL}/supp-management/file/upload/resourcePositionImage`,
            }}
          />
        </Form.Item>
        <Form.Item
          name="publishTime"
          label="发布时间（日本时间）"
          rules={[
            { required: true, message: '请选择发布时间' },
            {
              validator: (_, value: string) => {
                if (dayjs(value).isBefore(dayjs())) {
                  return Promise.reject(new Error('发布时间不能早于当前时间'));
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <DatePicker
            showTime
            placeholder="请选择发布时间(日本时间)"
            style={{ width: '100%' }}
            format="YYYY-MM-DD HH:mm"
          />
        </Form.Item>
        <Form.Item label="召回奖励" required>
          <Space.Compact style={{ width: "100%" }}>
            <Form.Item
              name="rewardType"
              rules={[{ required: true, message: "请选择" }]}
              // style={{ width: "60%" }}
            >
              <Radio.Group>
                {[...RewardTypeEnumMap.keys()].map((type) => {
                  const label = RewardTypeEnumMap.get(type);
                  return (
                    <Radio key={label} value={type}>
                      {label}
                    </Radio>
                  );
                })}
              </Radio.Group>
            </Form.Item>
            <Form.Item
              name="rewardCoins"
              rules={[{ required: true, message: "请输入" }]}
            >
              <InputNumber
                min={0}
                precision={0}
                style={{ width: '100%' }}
              />
            </Form.Item>
          </Space.Compact>
        </Form.Item>
        <Form.Item label="测试账号" name="testEmail">
          <div style={{ display: 'flex', gap: 10 }}>
            <Input maxLength={50} />
            <Button
              type="primary"
              disabled={!testEmail || !testEmail.length}
              onClick={onSubmitTest}
            >
              推送到测试邮箱
            </Button>
          </div>
        </Form.Item>
        <Form.Item>
          <Space style={{ width: '100%', justifyContent: 'center' }}>
            <Button type="primary" onClick={onSubmit}>
              提交
            </Button>
            <Button onClick={onCancel}>取消</Button>
          </Space>
        </Form.Item>
      </Form>
    </div>
  );
};

export default PushDetail;
